import { j as C } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: r = 20,
  height: t = 20,
  viewBox: o = "0 0 20 20",
  fill: s = "currentColor",
  ...n
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: o,
    fill: s,
    width: r,
    height: t,
    ...n,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M2.5 4.16258C2.5 3.24436 3.24385 2.5 4.16258 2.5H15.8374C16.7557 2.5 17.5 3.24385 17.5 4.16258V15.8374C17.5 16.7557 16.7562 17.5 15.8374 17.5H4.16258C3.24436 17.5 2.5 16.7562 2.5 15.8374V4.16258ZM4.16667 4.16667V15.8333H15.8333V4.16667H4.16667ZM6.64347 15.1507C6.12789 14.9274 5.63932 14.6536 5.18402 14.3353C6.22311 12.7294 8.03002 11.6667 10.0852 11.6667C12.0846 11.6667 13.8491 12.6726 14.9001 14.206C14.4532 14.5363 13.972 14.8231 13.4629 15.0598C12.706 14.0138 11.475 13.3333 10.0852 13.3333C8.65542 13.3333 7.39392 14.0534 6.64347 15.1507ZM10 10.8333C8.38917 10.8333 7.08333 9.5275 7.08333 7.91667C7.08333 6.30583 8.38917 5 10 5C11.6108 5 12.9167 6.30583 12.9167 7.91667C12.9167 9.5275 11.6108 10.8333 10 10.8333ZM10 9.16667C10.6903 9.16667 11.25 8.607 11.25 7.91667C11.25 7.22631 10.6903 6.66667 10 6.66667C9.30967 6.66667 8.75 7.22631 8.75 7.91667C8.75 8.607 9.30967 9.16667 10 9.16667Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as default
};
